<template>

  <div class="mol-color-theme-membership mol-center-card-width membership-explanation">
    <div class="free-tier-explanation">
      <p>The core essentials of myOscarList—checklists and film descriptions—are always <u class="no-wrap">free to use</u> and <u class="no-wrap">free of ads</u>.</p>
    </div>

    <div class="member-tier-explanation">
      <p>But if you enjoy myOscarList's features, and want to <span class="no-wrap">explore more</span>, <span class="no-wrap">research more</span>, and <span class="no-wrap">share more</span>, consider membership.</p>
      <div class="membership-includes-title">Membership Includes</div>
      <table>
        <tbody>
          <tr>
            <td class="feature-icon"><img :src="`${$imagePathBase}best-picture-achievement.svg`"></td>
            <td class="feature-description">Progress Rings for <b>every</b> ceremony.</td>
          </tr>

          <tr>
            <td class="feature-icon"><i class="fa fa-television"></i></td>
            <td class="feature-description">Streaming and Theater Options for <b>every</b> film.</td>
          </tr>

          <tr>
            <td class="feature-icon"><img :src="`${$imagePathBase}logos/content-providers/large-logos/tcm-logo-gold.svg`"></td>
            <td class="feature-description">Network Schedules for <b>TCM</b> & <b>AMC</b>.</td>
          </tr>

          <tr>
            <td class="feature-icon"><i class="fa fa-search"></i></td>
            <td class="feature-description">Searches that span <b>all</b> ceremonies' titles, nominees and plot keywords.</td>
          </tr>

          <tr>
            <td class="feature-icon"><img :src="`${$imagePathBase}logos/letterboxd/letterboxd-decal-dots-pos-gold.svg`"></td>
            <td class="feature-description"><b>Letterboxd</b> import of films you've already marked watched.</td>
          </tr>

        </tbody>

      </table>


<!--
      <ul>
        <li>Achievement Rings for <i>every</i> ceremony.</li>
        <li>Viewing Options for <i>every</i> film.</li>
        <li>Search results for titles, nominees and plot overviews of <i>all</i> ceremonies.</li>
        <li>A <i>Friends List</i>, allowing you to see progress of friends and acquaintances.</li>
        <li><i>Letterboxd</i> import of films you've already marked watched.</li>
      </ul>
-->
    </div>
  </div>

  <!-- storefront cards -->
  <div class="row justify-content-md-center storefront-row">

    <!-- storefront card for buying individual membership -->
    <div v-if="individualMembershipProduct" class="col col-xxl-4 col-xl-4 col-lg-5 col-md-6">
      <div class="product-card">

        <h4 class="product-card-title text-my-oscar-list"><img :src="`${$imagePathS3}products/individual-membership-icon.svg`" alt="Logo" class="logo-image"><span class="text-oscar">{{individualMembershipProduct.name}}</span></h4>

        <div class="product-description">
          <p>Includes full access to all of myOscarList's features.</p>
        </div>

        <div class="btn-group w-100" role="group" aria-label="individual membership prices">
          <template v-for="(price, index) in individualMembershipProduct.prices" :key="price.id">
            <input class="btn-check w-100" type="radio" :name="`${individualMembershipProduct.id}-price`" :id="price.id" :value="price" :checked="index===0" v-model="selectedIndividualPrice">
            <label class="btn btn-outline-mol btn-price-option w-100" :for="price.id">{{price.metadata.radio_button_text}}</label>
          </template>
        </div>

        <div class="price-description-section">
          <PriceDisplay :price="selectedIndividualPrice"></PriceDisplay>
        </div>

        <button class="w-100 btn btn-sm btn-mol btn-cta" type="button" @click="openCheckoutModal(individualMembershipProduct, selectedIndividualPrice)">
          {{selectedIndividualPrice.metadata?.trial_period_days? 'Try it Free' : 'Join'}}
        </button>
      </div>
    </div>


    <!-- storefront card for buying family membership -->
    <div v-if="familyMembershipProduct" class="col col-xxl-4 col-xl-4 col-lg-5 col-md-6">

      <div class="product-card">

        <h4 class="product-card-title text-my-oscar-list"><img :src="`${$imagePathS3}products/family-membership-icon.svg`" alt="Logo" class="logo-image"><span class="text-oscar">{{familyMembershipProduct.name}}</span></h4>

        <div class="product-description">
          <p>Includes full access to all of myOscarList's features for yourself and up to three other users.</p>
          <p>Ideal for couples, families and <span class="no-wrap">friend groups</span>.</p>
        </div>


        <div v-if="familyMembershipProduct.prices?.length === 1" class="family-membership-single-price">
          {{familyMembershipProduct.prices[0].metadata.radio_button_text}}
        </div>

        <div v-else class="btn-group w-100" role="group" aria-label="family membership prices">
          <template v-for="(price, index) in familyMembershipProduct.prices" :key="price.id">
            <input class="btn-check w-100" type="radio" :name="`${familyMembershipProduct.id}-price`" :id="price.id" :value="price" :checked="index===0" v-model="selectedFamilyPrice">
            <label class="btn btn-outline-mol btn-price-option w-100" :for="price.id">{{price.metadata.radio_button_text}}</label>
          </template>
        </div>

        <div class="price-description-section">
          <PriceDisplay :price="selectedFamilyPrice"></PriceDisplay>
        </div>

        <button class="w-100 btn btn-sm btn-mol btn-cta" type="button" @click="openCheckoutModal(familyMembershipProduct, selectedFamilyPrice)">
          {{selectedFamilyPrice.metadata?.trial_period_days? 'Try it Free' : 'Join'}}
        </button>
      </div>
    </div>
  </div>

  <GenericModal v-if="showPurchaseModal" @modal-closed="showPurchaseModal=false" class="purchase-modal">
    <template #header>
      {{purchaseInfo.product.name}}
    </template>
    <StripePurchase :product_name="purchaseInfo.product.name" :price_id="purchaseInfo.price.id" return_url="membership"></StripePurchase>
  </GenericModal>

</template>


<script>
import PriceDisplay from "@/components/purchases/PriceDisplay.vue";
import GenericModal from "@/components/modal/GenericModal.vue";
import StripePurchase from "@/components/purchases/StripePurchase.vue";
import axios from "axios";

export default {
  name: "MembershipStorefront",
  components: {StripePurchase, GenericModal, PriceDisplay},
  data() {
    return {
      individualMembershipProduct: null,
      selectedIndividualPrice: null,

      familyMembershipProduct: null,
      selectedFamilyPrice: null,

      showPurchaseModal: false,
      purchaseInfo: null, //{ product: null, price: null }
      purchaseResolution: null,
    }
  },

  async mounted() {
    return this.populateStorefront();
  },

  methods: {

    async populateStorefront() {
      const findProductResponse = await axios.post(`/api/membership/stripe/find-products`, {
        lookup_keys: ['individual-membership', 'family-membership']
      });
      const foundProducts = findProductResponse?.data || [];
      //console.log('foundProducts', foundProducts);

      this.individualMembershipProduct = foundProducts.find(p => p.metadata?.lookup_key === 'individual-membership');
      if (this.individualMembershipProduct) {
        this.individualMembershipProduct.prices.sort((p1, p2) => {
          return Number(p1.metadata.display_priority) - Number(p2.metadata.display_priority);
        });
        this.selectedIndividualPrice = this.individualMembershipProduct.prices[0];
      }

      this.familyMembershipProduct = foundProducts.find(p => p.metadata?.lookup_key === 'family-membership');
      if (this.familyMembershipProduct) {
        this.familyMembershipProduct.prices.sort((p1, p2) => {
          return Number(p1.metadata.display_priority) - Number(p2.metadata.display_priority);
        });
        this.selectedFamilyPrice = this.familyMembershipProduct.prices[0];
      }
    },

    openCheckoutModal(_product, _price) {
      this.purchaseInfo = { product: _product, price: _price };
      //console.log('purchaseInfo', this.purchaseInfo);
      this.showPurchaseModal = true;
    },

  }

}
</script>


<style scoped>

.logo-themed-header {
  color: var(--mol-color-gold);
  text-align: center;
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: xxx-large;

  svg {
    height: 1.125em;
    margin-right: 0.1em;
    margin-top: -0.1275em;
  }
}

.text-my-oscar-list {
  text-align: center;
  font-weight: 300;

  .text-oscar {
    font-weight: 600;
    padding-left: 0.05em;
    padding-right: 0.05em;
  }

  img {
    height: 1em;
    margin-right: 0.1em;
    margin-top: -0.2em;
  }
}


.product-card {
  position: relative;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;

  color: var(--mol-color-win-icon);
  background-color: var(--mol-color-gold-background);
  overflow: hidden;
  margin-bottom: 40px;
  padding: 2em;

  border: solid;
  border-width: 3px;
  border-color: var(--mol-color-gold);
  border-radius: 0.375rem;

  .product-card-title {
    color: var(--mol-color-win-icon);
    text-align: center;
    margin-bottom: 1em;
  }
}

.feature-section {
  position: relative;

  &:first-of-type {
    margin-top: 50px;
  }

  color: var(--mol-color-win-icon);
  background-color: white;
  overflow: hidden;
  margin-bottom: 40px;
  padding: 2em;

  border: solid;
  border-width: 3px;
  border-color: var(--mol-color-gold);
  border-radius: 0.375rem;

  .feature-section-title {
    color: var(--mol-color-win-icon);
    text-align: center;
    margin-bottom: 1em;
  }
}

.product-description {
  text-align: center;
  margin-bottom: 20px;

  min-height: 100px;
}

.my-membership-details {
  text-align: center;
  margin-bottom: 20px;

  .cancel-at {
    color: var(--mol-color-red-carpet);
  }
}


.price-description-section {
  margin-top: 20px;
  margin-bottom: 50px;
}

.btn-price-option {
  border-radius: 0;

  &:first-of-type {
    border-radius: 0.375rem 0 0 0.375rem;
  }
  &:last-of-type {
    border-radius: 0 0.375rem 0.375rem 0;
  }
}

.free-trial-msg {
  font-weight: bold;
}

.btn-cta {
  font-size: large;
  font-weight: bold;
  height: 3em;
}


.purchase-confirmation {
  color: var(--mol-color-win-icon);
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
  font-size: large;
}

.family-plan-message {
  text-align: center;
}

.family-membership-single-price {
  text-align: center;
  font-weight: bold;
  font-size: larger;
}

.membership-explanation {
  margin-top: 50px;
  margin-bottom: 50px;
  padding-right: 1em;
  padding-left: 1em;



  hr {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }

  ul, ol {
    padding-left: 1em;
  }

  .free-tier-explanation {
    margin-bottom: 1.5em;
  }

  .member-tier-explanation {

    .membership-includes-title {
      font-weight: 500;
      font-size: larger;
      margin-bottom: 7px;
    }

    tr {

      .feature-icon {
        padding-right: 0.3em;
        text-align: center;
        vertical-align: top;
        img {
          height: 1em;
          max-width: 1.2em;
        }

        .oscar-pool-img {
          border-radius: 20%;
          border-style: solid;
          border-width: 0.1px;
          border-color: lightgrey;
        }
      }

      .feature-description {
        padding-bottom: 10px;
      }
    }
  }
}

b {
  font-weight: 500;
}

</style>